import { AdminAppState, AuthState } from '../../state';
import { getAuth } from './get-auth';

export const getAuthExpiresAt = (store: AdminAppState): Date | null => {
  const expiresAt = getAuth(store).expiresAt;
  return expiresAt ? new Date(expiresAt) : null;
};
